import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import portalAxios from "../portalAxios";
import {
  downloadPdf,
  toBlobApiError,
} from "../../training/slice-extensions/training-record-slice-extension";

/**
 * Downloads the member's (or ward's) training record PDF from the portal, rendered on request and
 * never stored (PD-0018). A 409 means the school has not completed its business details yet.
 */
export const downloadPortalRecord = createAsyncThunk<
  string,
  { memberId: string; enrolmentId: string },
  { rejectValue: ApiErrorResponse }
>("portal/downloadRecord", async ({ memberId, enrolmentId }, { rejectWithValue }) => {
  try {
    return await downloadPdf(`/portal/members/${memberId}/enrolments/${enrolmentId}/record`, portalAxios);
  } catch (error: unknown) {
    return rejectWithValue(await toBlobApiError(error));
  }
});
